export default __webpack_public_path__ + "static/media/48_desktop.403ce78f.jpg";